import React from "react";
import { AppBar, makeStyles, useTheme, Box } from "@material-ui/core";
import PriceText from "./PriceText";
import { Theme } from "../.themes";
import { BrandAreaEnum, BrandsEnum, GetBrandArea } from "../enums";
import clsx from "clsx";
import Summary from "./Summary";
import { CoveragePrice } from "../store/Insurance";

const useStyles = makeStyles((t: Theme) => ({
  bar: {
    top: 0,
    backgroundColor: t.footerBar?.backgroundColor ?? "#1D1F20",
    "& *": {
      color: t.footerBar?.textColor ?? t.palette.secondary.main,
    },
    margin: "32px 0",
    boxShadow: `0px 2px 2px -1px rgb(0 0 0 / 10%), 0px 2px 5px 0px rgb(0 0 0 / 10%), 0px 1px 5px 0px rgb(0 0 0 / 8%)`,
    ...t.footer?.bar,
  },
  box: {
    margin: t.spacing(1),
    padding: 0,
    ...t.footer?.box,
  },
  expandLess: {
    textAlign: "center",
    maxWidth: 385,
    margin: "0 auto",
    marginTop: 16,
    ...t.footer?.expandLess,
  },
  barContainer: {
    width: "100%",
    boxSizing: "border-box",
    maxWidth: t.pageMaxWidth ?? 1208,
    margin: "0 auto",
    padding: `0 ${t.spacing(2)}px`,
    ...t.footer?.barContainer,
  },
  icons: {
    color: t.footerBar?.textColor ?? t.palette.secondary.main,
    marginBottom: -5,
  },
  priceText: {},
  dontShowPrice: {
    display: "none",
  },
}));

export interface Price {
  title: string;
  price: string;
}

export type FooterBaseProps = {
  title: string;
  price: string;
  totalPriceTooltip: string;
  purchaseButton: string;
  prices?: Price[];
  expanded: boolean;
  footerExpanded: Function;
  secondaryPrice: CoveragePrice;
  showSecondaryPrice?: boolean;
};

export const FooterBase: React.FC<FooterBaseProps> = (props: FooterBaseProps) => {
  const theme: Theme = useTheme();
  const css = useStyles(theme);

  const lastIndex = (props.prices?.length || 0) - 1;

  return (
    <AppBar id='app_bar_sticky' position='sticky' className={css.bar} color='secondary'>
      <div className={css.barContainer} id='ws-footer'>
        <Box component='div' className={css.expandLess}>
          <Box>
            <Summary
              summary={props.prices?.map(
                (item, index) =>
                  index === lastIndex && (
                    <PriceText
                      text={item.title}
                      priceText={item.price}
                      textVariant={index === lastIndex ? "h5" : "h6"}
                      priceTextClass={
                        index !== lastIndex && GetBrandArea(theme.brand ?? BrandsEnum.None) === BrandAreaEnum.IMF
                          ? clsx(css.dontShowPrice)
                          : clsx(css.priceText)
                      }
                      secondaryPrice={props.secondaryPrice}
                      showSecondaryPrice={props.showSecondaryPrice}
                    />
                  ),
              )}
            ></Summary>
          </Box>
        </Box>
      </div>
    </AppBar>
  );
};
